export default async function deleteFromBasket({ props, graphql, state }) {
  const { orderItemId } = props
  const orderId = state.get('basket.orderId')

  await graphql.mutate(`{
    deleteOrderItem(orderId: "${orderId}", orderItemId: "${orderItemId}")
  }`)
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/deleteFromBasket.js